import React, { memo } from 'react';
import cn from 'classnames';

const Image = ({ image, onClick, imgStyle, style, className, alt = '' }) => {
  const handleClick = e => {
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <picture style={style} className={cn(className)}>
      {image.images.sources.map(source => (
        <source key={source.type} {...source} />
      ))}
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
      <img
        alt={alt}
        {...image.images.fallback}
        style={imgStyle}
        role={onClick ? 'button' : null}
        onClick={handleClick}
        onKeyDown={e => e.key === 'Enter' && handleClick(e)}
      />
    </picture>
  );
};

export default memo(Image);
